import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SectionCardProps {
    icon?: LucideIcon;
    title: string;
    subtitle?: string;
    right?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

export function SectionCard({
    icon: Icon,
    title,
    subtitle,
    right,
    children,
    className,
}: SectionCardProps) {
    return (
        <div
            className={cn(
                "bg-white rounded-xl border border-gray-100 p-5",
                className
            )}
        >
            <div className="flex items-center justify-between mb-4 gap-4 flex-wrap">
                <div className="flex items-center gap-2 min-w-0">
                    {Icon && <Icon className="w-4 h-4 text-gray-400 shrink-0" />}
                    <h3 className="text-sm font-semibold text-gray-700 truncate">
                        {title}
                    </h3>
                    {subtitle && (
                        <span className="text-xs text-gray-400 truncate">
                            · {subtitle}
                        </span>
                    )}
                </div>
                {right && <div className="shrink-0">{right}</div>}
            </div>
            {children}
        </div>
    );
}
